import React, {useEffect, useState} from 'react';
import Axios from 'axios';
import { Modal } from 'react-bootstrap';
import '../App.css';
import { useNavigate } from "react-router-dom";
import { Alert } from 'react-bootstrap';
import { applySessionData, clearImpersonationState, getDefaultSessionPath, snapshotCurrentSession } from '../utils/impersonation';

function Grillasausuariosadmin (props){
    const navigate = useNavigate();

    const [casinos, setCasinos] = useState([]);
    const [perfiles, setPerfiles] = useState([]);
    const [datos, setDatos] = useState([]);
    const [searchmail, setSearchmail] = useState();
    const [changecasino, setChangeCasino] = useState('0');
    const [changeperfil, setChangePerfil] = useState('0');
    const [idsaldo, setIdsaldo] = useState();
    const [cantidadtickets, setCantidadTickets] = useState('');
    const [valorTicket, setValorTicket] = useState();

    const [perfil_id, setPerfil_id] = useState();
    const [casino_id, setCasino_id] = useState();
    
    const [mail, setMail] = useState();
    const [rut, setRut] = useState();
    
    const [modificapassword, setModificapassword] = useState();
    const [modificapasswordrpt, setModificapasswordrpt] = useState();
    const [modificanombre, setModificanombre] = useState();
    const [modificaapellido, setModificaapellido] = useState();
    const [modificaperfilid, setModificaperfilid] = useState();
    const [modificacasinoid, setModificacasinoid] = useState();
    const [resetpassword, setResetpassword] = useState();
    const [resetpasswordrpt, setResetpasswordrpt] = useState();

    const [creapassword, setCreapassword] = useState();
    const [creapasswordrpt, setCreapasswordrpt] = useState();
    const [creanombre, setCreanombre] = useState();
    const [creaapellido, setCreaapellido] = useState();
    const [creaperfilid, setCreaperfilid] = useState('0');
    const [creacasinoid, setCreacasinoid] = useState('0');
    const [crearut, setCrearut] = useState();
    const [creamail, setCreamail] = useState();





    const [show, setShow] = useState(false);

    
    const [showdesactivar, setShowdesactivar] = useState(false);
    const [showactivar, setShowactivar] = useState(false);
    const [showreset, setShowreset] = useState(false);
    const [showmodificar, setShowmodificar] = useState(false);
    const [showcrear, setShowcrear] = useState(false);
  

    const [tituloAlert, setTituloAlert] = useState('')
    const [textoAlert, setTextoAlert] = useState('')
    const [claseAlert, setClaseAlert] = useState('')
    const [alert, setAlert] = useState(false);

    const [tituloAlert1, setTituloAlert1] = useState('')
    const [textoAlert1, setTextoAlert1] = useState('')
    const [claseAlert1, setClaseAlert1] = useState('')
    const [alert1, setAlert1] = useState(false);

    const [tituloAlertActivate, setTituloAlertActivate] = useState('')
    const [textoAlertActivate, setTextoAlertActivate] = useState('')
    const [claseAlertActivate, setClaseAlertActivate] = useState('')
    const [alertActivate, setAlertActivate] = useState(false);

    const [tituloAlertActivate1, setTituloAlertActivate1] = useState('')
    const [textoAlertActivate1, setTextoAlertActivate1] = useState('')
    const [claseAlertActivate1, setClaseAlertActivate1] = useState('')
    const [alertActivate1, setAlertActivate1] = useState(false);    

    const [tituloAlertDesactivate, setTituloAlertDesactivate] = useState('')
    const [textoAlertDesactivate, setTextoAlertDesactivate] = useState('')
    const [claseAlertDesactivate, setClaseAlertDesactivate] = useState('')
    const [alertDesactivate, setAlertDesactivate] = useState(false);    

    const [tituloAlertDesactivate1, setTituloAlertDesactivate1] = useState('')
    const [textoAlertDesactivate1, setTextoAlertDesactivate1] = useState('')
    const [claseAlertDesactivate1, setClaseAlertDesactivate1] = useState('')
    const [alertDesactivate1, setAlertDesactivate1] = useState(false);

    const [tituloAlertReset, setTituloAlertReset] = useState('')
    const [textoAlertReset, setTextoAlertReset] = useState('')
    const [claseAlertReset, setClaseAlertReset] = useState('')
    const [alertReset, setAlertReset] = useState(false);

    const [tituloAlertReset1, setTituloAlertReset1] = useState('')
    const [textoAlertReset1, setTextoAlertReset1] = useState('')
    const [claseAlertReset1, setClaseAlertReset1] = useState('')
    const [alertReset1, setAlertReset1] = useState(false);

    const [tituloAlertModifica, setTituloAlertModifica] = useState('')
    const [textoAlertModifica, setTextoAlertModifica] = useState('')
    const [claseAlertModifica, setClaseAlertModifica] = useState('')
    const [alertModifica, setAlertModifica] = useState(false);

    const [tituloAlertModifica1, setTituloAlertModifica1] = useState('')
    const [textoAlertModifica1, setTextoAlertModifica1] = useState('')
    const [claseAlertModifica1, setClaseAlertModifica1] = useState('')
    const [alertModifica1, setAlertModifica1] = useState(false);

    const [tituloAlertCrea, setTituloAlertCrea] = useState('')
    const [textoAlertCrea, setTextoAlertCrea] = useState('')
    const [claseAlertCrea, setClaseAlertCrea] = useState('')
    const [alertCrea, setAlertCrea] = useState(false);

    const [tituloAlertCrea1, setTituloAlertCrea1] = useState('')
    const [textoAlertCrea1, setTextoAlertCrea1] = useState('')
    const [claseAlertCrea1, setClaseAlertCrea1] = useState('')
    const [alertCrea1, setAlertCrea1] = useState(false);

    const [classWaitProcess, setClassWaitProcess] = useState('waitProcess')    

    let statuscall = '' 
    

    const perfilesList = perfiles.map((item, i) => 
    <option key={i} value={item.id}>{item.nombre}</option>);
    
    const casinosList = casinos.map((item, i) =>
    <option key={i} value={item.id}>{item.nombre}</option>);

    const dataList = datos.map((item, i) => 
    <div key={i} className='row'>
         <div className='saLineGrid col col-xl-3 col-lg-3 col-md-3 col-sm-3'>{item.mail}</div>
         <div className='saLineGrid col col-xl-2 col-lg-2 col-md-3 col-sm-3'>{item.user_state_id===1?<button onClick={() => activarUsuario(item)} className='btn btn-adminsaprivateRegular'>Activar</button>:<button onClick={() => desactivarUsuario(item)} className='btn btn-adminsaprivateRegular'>Desactivar</button>}</div>         
         <div className='saLineGrid col col-xl-2 col-lg-2 col-md-3 col-sm-3'><button onClick={() => resetPasswordUsuario(item)} className='btn btn-adminsaprivateRegular'>Reset Password</button></div>         
         <div className='saLineGrid col col-xl-2 col-lg-2 col-md-3 col-sm-3'><button onClick={() => modificarUsuario(item)} className='btn btn-adminsaprivateRegular'>Modificar</button></div>
         <div className='saLineGrid col col-xl-3 col-lg-3 col-md-12 col-sm-12'>{item.profile_id === 4 ? <span className='text-muted'>Superadmin</span> : <button onClick={() => impersonarUsuario(item)} className='btn btn-adminsaprivateRegular'>Impersonar</button>}</div>
    </div>);

    useEffect(() => {
        let idperfilstr = window.localStorage.getItem('MY_APP_STATE_PROF_ID').replace('"', '')
        let idperfil = idperfilstr.replace('"', '')

        Axios.get(process.env.REACT_APP_DATAUSER, {
            params: {
                id_perfil: idperfil
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setCasinos(response.data.casinos)
            setPerfiles(response.data.perfiles)
        }).catch(error => {
            return error     
        });
    }, []);





    const handlerChangeCasino= (e) => {
        setChangeCasino(e.target.value)
    }

    const handlerChangePerfil= (e) => {
        setChangePerfil(e.target.value)
    }    

    const handlerChangeMail= (e) => {
        setSearchmail(e.target.value)
    }    

    const handelSearch = () => {
        setDatos([]);
        Axios.get(process.env.REACT_APP_URLUSERSEARCH2, {
            params: {
                mail: searchmail,
                casino_id: changecasino,
                perfil_id: changeperfil
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatos(response.data.usuarios)
        }).catch(error => {
            return error     
        });
    }

    const activarUsuario = (item) => {       
        setMail(item.mail) 
        handleShowactivar()
    }

    const desactivarUsuario = (item) => {
        setMail(item.mail) 
        handleShowdesactivar()
    }

    const resetPasswordUsuario  = (item) => {
        setMail(item.mail)
        setResetpassword(item.password)
        setResetpasswordrpt(item.password)
        handleShowreset()
    }

    const modificarUsuario  = (item) => {
        console.log("casino: " + item.casino_id)
        console.log("perfil: " + item.profile_id)
        setMail(item.mail)
        setRut(item.rut)
        setModificanombre(item.nombre)
        setModificaapellido(item.apellido)
        setModificapassword(item.password)
        setModificapasswordrpt(item.password)
        setPerfil_id(item.profile_id)
        setCasino_id(item.casino_id)
        handleShowmodificar()
    }

    const normalizeStorageValue = (key) => {
        const rawValue = window.localStorage.getItem(key)
        return rawValue == null ? '' : rawValue.replace(/"/g, '')
    }

    const getImpersonationUrl = () => {
        const authUrl = process.env.REACT_APP_URLAUTENTICATE || ''

        if(authUrl !== '')
        {
            return authUrl.replace(/\/autenticate\/user\/?$/, '') + '/admin/impersonate/user'
        }

        return `${window.location.origin}/admin/impersonate/user`
    }

    const impersonarUsuario = async (item) => {
        const actorMail = normalizeStorageValue('MY_APP_STATE_USER')
        const actorAuthCode = normalizeStorageValue('MY_APP_STATE_AUTHCODE')
        const actorProfileId = normalizeStorageValue('MY_APP_STATE_PROF_ID')

        if(actorProfileId !== '4' || actorMail === '' || actorAuthCode === '')
        {
            window.alert('La sesión actual no corresponde a un superadmin válido.')
            return
        }

        if(!window.confirm('Ingresará como ' + item.mail + '. ¿Desea continuar?'))
        {
            return
        }

        snapshotCurrentSession('/AdminUsers/' + actorAuthCode)

        const data = {
            actor_mail: actorMail,
            actor_authcode: actorAuthCode,
            target_mail: item.mail
        }

        await Axios.post(getImpersonationUrl(), data, {
            timeout: process.env.REACT_APP_TIMEOUT,
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then(res => statuscall = res).catch(err => statuscall = err.response)

        if(statuscall?.status === 200 && statuscall?.data?.MessageCode === '0')
        {
            applySessionData(item.mail, statuscall.data)
            navigate(getDefaultSessionPath(statuscall.data.roles) + '/' + statuscall.data.AuthCode)
            return
        }

        clearImpersonationState()
        window.alert(statuscall?.data?.Message || 'No fue posible iniciar la impersonación.')
    }

    const crearUsuario = () =>{
        setShowcrear(true) 
    }

    const handleClosecrear = () =>{
        setShowcrear(false)
    }

    const handleCantidad = async (e) =>{
        setCantidadTickets(e.target.value)
    }


    const handleShowdesactivar = () => setShowdesactivar(true)
    const handleShowactivar = () => setShowactivar(true)
    const handleShowreset = () => setShowreset(true)
    const handleShowmodificar = () => setShowmodificar(true)

    const handleClosedesactivar = () => setShowdesactivar(false)
    const handleCloseactivar = () => setShowactivar(false)
    const handleClosereset = () => setShowreset(false)
    const handleClosemodificar = () => setShowmodificar(false)

    const handlerChangePass = (e) => setResetpassword(e.target.value)
    const handlerChangePassRpt = (e) => setResetpasswordrpt(e.target.value)

    const handlerChangeCasinoID = (e) => {
            console.log("Casino: " + e.target.value)
            setModificacasinoid(e.target.value)
            setCasino_id(e.target.value)
    }

    const handlerChangePerfilID = (e) => {
        setModificaperfilid(e.target.value)
        setPerfil_id(e.target.value)
    }
    
    const handlerChangeModificapassword = (e) => setModificapassword(e.target.value)
    const handlerChangeModificapasswordrpt = (e) => setModificapasswordrpt(e.target.value)
    const handlerChangeModificanombre = (e) => setModificanombre(e.target.value)
    const handlerChangemodificaapellido = (e) => setModificaapellido(e.target.value)

    const handlerChangecreamail = (e) => setCreamail(e.target.value)
    const handlerChangecrearut = (e) => {
        // Despejar Puntos
        let valor = e.target.value.replace('.','');
        // Despejar Guión
        valor = valor.replace('-','');
            
        // Aislar Cuerpo y Dígito Verificador
        let cuerpo = valor.slice(0,-1);
        let dv = valor.slice(-1).toUpperCase();
            
        // Formatear RUN
        setCrearut(cuerpo + '-'+ dv)
    }
    const handlerChangecreapassword = (e) => setCreapassword(e.target.value)
    const handlerChangecreapasswordrpt = (e) => setCreapasswordrpt(e.target.value)
    const handlerChangecreanombre = (e) => setCreanombre(e.target.value)
    const handlerChangecreaapellido = (e) => setCreaapellido(e.target.value)
    const handlerChangecreaCasinoID = (e) => setCreacasinoid(e.target.value)
    const handlerChangecreaPerfilID = (e) => setCreaperfilid(e.target.value)

    const creauser = async () =>{
        //Post to backend activacion
        setAlertCrea(false)
        const data = {   
            password: creapassword,
            nombre: creanombre,
            apellido: creaapellido,
            profile_id: creaperfilid,
            casino_id: creacasinoid,
            rut: crearut,
            mail: creamail
        }
        const crearusuario = await Axios.post(process.env.REACT_APP_URLCREAUSERADMIN, data, {
            timeout: process.env.REACT_APP_TIMEOUT,
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then(res => statuscall = res).catch(err => statuscall = err.response)
        if(statuscall.status == 200)
        {
            handelSearch()
            setTituloAlertCrea1('Creación de usuario')
            setTextoAlertCrea1('Usuario creado')
            setClaseAlertCrea1('success')
            setAlertCrea1(true)
            setTimeout(() =>{
                setShowcrear(false)
                setAlertCrea1(false)
            }, 3000)
        }else{
            setTituloAlertCrea1('Creación de usuario')
            setTextoAlertCrea1('Error en el sistema. Intentelo mas tarde.')
            setClaseAlertCrea1('danger')
            setAlertCrea1(true)
            setTimeout(() =>{
                setShowcrear(false)
                setAlertCrea1(false)
            }, 3000)            
        }        
    }

    const confirmaActivacion = async () =>{
        //Post to backend activacion
        setAlertActivate(false)
        const data = {   
            mail: mail
        }
        const activarusuario = await Axios.post(process.env.REACT_APP_URLACTIVATEADMIN, data, {
            timeout: process.env.REACT_APP_TIMEOUT,
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then(res => statuscall = res).catch(err => statuscall = err.response)
        if(statuscall.status == 200)
        {
            handelSearch()
            setTituloAlertActivate1('Activacion de usuario')
            setTextoAlertActivate1('Usuario activado')
            setClaseAlertActivate1('success')
            setAlertActivate1(true)
            setTimeout(() =>{
                setShowactivar(false)
                setAlertActivate1(false)
            }, 3000)
        }else{
            setTituloAlertActivate1('Activacion de usuario')
            setTextoAlertActivate1('Error en el sistema. Intentelo mas tarde.')
            setClaseAlertActivate1('danger')
            setAlertActivate1(true)
            setTimeout(() =>{
                setShowactivar(false)
                setAlertActivate1(false)
            }, 3000)            
        }
    }

    const confirmaDesactivacion = async () =>{
        //Post to backend desactivacion
        setAlertDesactivate(false)
        const data = {   
            mail: mail
        }         
        const desactivarusuario = await Axios.post(process.env.REACT_APP_URLDESACTIVATEADMIN, data, {
            timeout: process.env.REACT_APP_TIMEOUT,
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then(res => statuscall = res).catch(err => statuscall = err.response)
        if(statuscall.status == 200)
        {
            handelSearch()
            setTituloAlertDesactivate1('Desactivacion de usuario')
            setTextoAlertDesactivate1('Usuario desactivado')
            setClaseAlertDesactivate1('success')
            setAlertDesactivate1(true)
            setTimeout(() =>{
                setShowdesactivar(false)
                setAlertDesactivate1(false)
            }, 3000)
        }else{
            setTituloAlertDesactivate1('Desactivacion de usuario')
            setTextoAlertDesactivate1('Error en el sistema. Intentelo mas tarde.')
            setClaseAlertDesactivate1('danger')
            setAlertDesactivate1(true)
            setTimeout(() =>{
                setShowdesactivar(false)
                setAlertDesactivate1(false)
            }, 3000)            
        }        
    }

    const confirmaReset = async () =>{
        //Post to backend reset password
        setAlertReset(false)
        const data = {   
            mail: mail,
            password: resetpassword 
        }         
        const reestablecerpassword = await Axios.post(process.env.REACT_APP_URLRESETPASSWORD, data, {
            timeout: process.env.REACT_APP_TIMEOUT,
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then(res => statuscall = res).catch(err => statuscall = err.response)
        if(statuscall.status == 200)
        {
            handelSearch()
            setTituloAlertReset1('Reset password')
            setTextoAlertReset1('Password re-establecida')
            setClaseAlertReset1('success')
            setAlertReset1(true)
            setTimeout(() =>{
                setShowreset(false)
                setAlertReset1(false)
            }, 3000)
        }else{
            setTituloAlertReset1('Reset password')
            setTextoAlertReset1('Error en el sistema. Intentelo mas tarde.')
            setClaseAlertReset1('danger')
            setAlertReset1(true)
            setTimeout(() =>{
                setShowreset(false)
                setAlertReset1(false)
            }, 3000)            
        }
    }

    const confirmamodifica = async () =>{
        //Validaciones antes de enviar al backend
        if(modificanombre != '' && modificanombre != null && modificanombre != 'undefined')
        {
            if(modificaapellido != '' && modificaapellido != null && modificaapellido != 'undefined')
            {
                if(modificapassword != '' && modificapassword != null && modificapassword != 'undefined')
                {
                    if(modificapasswordrpt != '' && modificapasswordrpt != null && modificapasswordrpt != 'undefined')
                    {
                        if(modificapassword === modificapasswordrpt)
                        {
                            setTituloAlertModifica('Modifica usuario')
                            setTextoAlertModifica('Se modificará el usuario: ' + mail + ' . Esta seguro de realizar esta acción?')
                            setClaseAlertModifica('warning')
                            setAlertModifica(true)
                        }
                        else{
                            setTituloAlertModifica1('Modifica usuario')
                            setTextoAlertModifica1('Las contraseñas no coinciden')
                            setClaseAlertModifica1('danger')
                            setAlertModifica1(true)
                            setTimeout(() =>{
                                setAlertModifica1(false)
                            }, 3000)   
                        }
                    }
                    else{
                        setTituloAlertModifica1('Modifica usuario')
                        setTextoAlertModifica1('Debe ingresar la password de repetición')
                        setClaseAlertModifica1('danger')
                        setAlertModifica1(true)
                        setTimeout(() =>{
                            setAlertModifica1(false)
                        }, 3000)
                    }
                }else{
                    setTituloAlertModifica1('Modifica usuario')
                    setTextoAlertModifica1('Debe ingresar la password')
                    setClaseAlertModifica1('danger')
                    setAlertModifica1(true)
                    setTimeout(() =>{
                        setAlertModifica1(false)
                    }, 3000)
                }  
            }else{
                setTituloAlertModifica1('Modifica usuario')
                setTextoAlertModifica1('Debe ingresar el apellido')
                setClaseAlertModifica1('danger')
                setAlertModifica1(true)
                setTimeout(() =>{
                    setAlertModifica1(false)
                }, 3000)
            }
        }else{
            setTituloAlertModifica1('Modifica usuario')
            setTextoAlertModifica1('Debe ingresar el nombre')
            setClaseAlertModifica1('danger')
            setAlertModifica1(true)
            setTimeout(() =>{
                setAlertModifica1(false)
            }, 3000)            
        }
        
        
        
        
        

    } 
    

    const activacionUsuario = async () =>{
        setTituloAlertActivate('Activación de usuario')
        setTextoAlertActivate('Activara el usuario: ' + mail + ' . Esta seguro de realizar esta acción?')
        setClaseAlertActivate('warning')
        setAlertActivate(true)
    }

    const desactivacionUsuario = async () =>{
        setTituloAlertDesactivate('Desactivación de usuario')
        setTextoAlertDesactivate('Desactivara el usuario: ' + mail + ' . Esta seguro de realizar esta acción?')
        setClaseAlertDesactivate('warning')
        setAlertDesactivate(true)
    }

    const confirmacrea = async () =>{
        if(creanombre != '' && creanombre != null && creanombre != 'undefined')
        {
            if(creaapellido != '' && creaapellido != null && creaapellido != 'undefined')
            {
                if(creaperfilid != '' && creaperfilid != null && creaperfilid != 'undefined' && creaperfilid != '0')
                {
                    if(creacasinoid != '' && creacasinoid != null && creacasinoid != 'undefined' && creacasinoid != '0')
                    {
                        if(crearut != '' && crearut != null && crearut != 'undefined')
                        {
                            if(creamail != '' && creamail != null && creamail != 'undefined')
                            {
                                if(creapassword != '' && creapassword != null && creapassword != 'undefined')
                                {
                                    if(creapasswordrpt != '' && creapasswordrpt != null && creapasswordrpt != 'undefined')
                                    {
                                        if(creapasswordrpt === creapassword)
                                        {
                                            setTituloAlertCrea('Crear usuario')
                                            setTextoAlertCrea('Creara el usuario: ' + creamail + ' . Esta seguro de realizar esta acción?')
                                            setClaseAlertCrea('warning')
                                            setAlertCrea(true)   
                                        }
                                        else
                                        {
                                            setTituloAlertCrea1('Crear usuario')
                                            setTextoAlertCrea1('Las contraseñas no coinciden')
                                            setClaseAlertCrea1('danger')
                                            setAlertCrea1(true)
                                            setTimeout(() =>{
                                                setAlertCrea1(false)
                                            }, 3000)         
                                        }
                                    }
                                    else
                                    {
                                        setTituloAlertCrea1('Crear usuario')
                                        setTextoAlertCrea1('Debe ingresar password de repeticion')
                                        setClaseAlertCrea1('danger')
                                        setAlertCrea1(true)
                                        setTimeout(() =>{
                                            setAlertCrea1(false)
                                        }, 3000)   
                                    }
                                }else{
                                    setTituloAlertCrea1('Crear usuario')
                                    setTextoAlertCrea1('Debe ingresar una contraseña')
                                    setClaseAlertCrea1('danger')
                                    setAlertCrea1(true)
                                    setTimeout(() =>{
                                        setAlertCrea1(false)
                                    }, 3000)                                       
                                }
                            }else{
                                setTituloAlertCrea1('Crear usuario')
                                setTextoAlertCrea1('Debe ingresar el mail')
                                setClaseAlertCrea1('danger')
                                setAlertCrea1(true)
                                setTimeout(() =>{
                                    setAlertCrea1(false)
                                }, 3000)
                            }
                        }else{
                            setTituloAlertCrea1('Crear usuario')
                            setTextoAlertCrea1('Debe ingresar el rut')
                            setClaseAlertCrea1('danger')
                            setAlertCrea1(true)
                            setTimeout(() =>{
                                setAlertCrea1(false)
                            }, 3000)                            
                        }
                    }else{
                        setTituloAlertCrea1('Crear usuario')
                        setTextoAlertCrea1('Debe seleccionar un casino')
                        setClaseAlertCrea1('danger')
                        setAlertCrea1(true)
                        setTimeout(() =>{
                            setAlertCrea1(false)
                        }, 3000)                        
                    }
                }else{
                    setTituloAlertCrea1('Crear usuario')
                    setTextoAlertCrea1('Debe seleccionar un perfil')
                    setClaseAlertCrea1('danger')
                    setAlertCrea1(true)
                    setTimeout(() =>{
                        setAlertCrea1(false)
                    }, 3000)                    
                }
            }else{
                setTituloAlertCrea1('Crear usuario')
                setTextoAlertCrea1('Debe ingresar el apellido')
                setClaseAlertCrea1('danger')
                setAlertCrea1(true)
                setTimeout(() =>{
                    setAlertCrea1(false)
                }, 3000)                
            }
        }else{
            setTituloAlertCrea1('Crear usuario')
            setTextoAlertCrea1('Debe ingresar el nombre')
            setClaseAlertCrea1('danger')
            setAlertCrea1(true)
            setTimeout(() =>{
                setAlertCrea1(false)
            }, 3000)            
        }
        
        
        
        
        

        
        
    }

    const resetPassword = async () =>{
        if(resetpassword != '' && resetpassword != null && resetpassword != 'undefined')
        {
            if(resetpasswordrpt != '' && resetpasswordrpt != null && resetpasswordrpt != 'undefined')
            {
                if(resetpassword === resetpasswordrpt)
                {
                    setTituloAlertReset('Reset password')
                    setTextoAlertReset('Reestablecera la password del usuario: ' + mail + ' . Esta seguro de realizar esta acción?')
                    setClaseAlertReset('warning')
                    setAlertReset(true)      
                }
                else
                {
                    setTituloAlertReset1('Reset password')
                    setTextoAlertReset1('Las contraseñas no coinciden')
                    setClaseAlertReset1('danger')
                    setAlertReset1(true)
                    setTimeout(() =>{
                        setAlertReset1(false)
                    }, 3000)                    
                }
            }
            else
            {
                setTituloAlertReset1('Reset password')
                setTextoAlertReset1('Debe completar el campo de repetición de contraseña.')
                setClaseAlertReset1('danger')
                setAlertReset1(true)
                setTimeout(() =>{
                    setAlertReset1(false)
                }, 3000)                
            }
        }else{
            setTituloAlertReset1('Reset password')
            setTextoAlertReset1('Debe completar el campo contraseña.')
            setClaseAlertReset1('danger')
            setAlertReset1(true)
            setTimeout(() =>{
                setAlertReset1(false)
            }, 3000)            
        }  
    }
    
    const modificauser = async () =>{
        //Post to backend modificacion
        setAlertModifica(false)
        console.log("Mail: " + mail)
        console.log("Nuevo casino: " + modificacasinoid)
        const data = {   
            mail: mail,
            nombre: modificanombre,
            apellido: modificaapellido,
            password: modificapassword,
            profile_id: modificaperfilid || perfil_id,
            casino_id: modificacasinoid || casino_id
        }    

        const modificacionusuario = await Axios.post(process.env.REACT_APP_URLMODIFICAUSUARIO, data, {
            timeout: process.env.REACT_APP_TIMEOUT,
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then(res => statuscall = res).catch(err => statuscall = err.response)
        if(statuscall.status == 200)
        {
            handelSearch()
            setTituloAlertModifica1('Modificacion de usuario')
            setTextoAlertModifica1('Usuario modificado')
            setClaseAlertModifica1('success')
            setAlertModifica1(true)
            setTimeout(() =>{
                setShowmodificar(false)
                setAlertModifica1(false)
            }, 3000)
        }else{
            setTituloAlertModifica1('Modificacion de usuario')
            setTextoAlertModifica1('Error en el sistema. Intentelo mas tarde.')
            setClaseAlertModifica1('danger')
            setAlertModifica1(true)
            setTimeout(() =>{
                setShowmodificar(false)
                setAlertModifica1(false)
            }, 3000)            
        }        
    }

    const confirmaIngresoSaldo = async () =>{
        setAlert(false)

        const data = {   
            mail: idsaldo,    
            cantidad: cantidadtickets,
            valor_ticket: valorTicket
        }

        const ingresaSaldoTickets = await Axios.post(process.env.REACT_APP_CREATESALDO, data, {
            timeout: process.env.REACT_APP_TIMEOUT,
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then(res => statuscall = res).catch(err => statuscall = err.response)

        if(statuscall.status == 200)
        {
            if(statuscall.data.MessageCode == '0')
            {
                setClassWaitProcess('waitProcess')
                setTituloAlert1('Creacion de saldos')
                setTextoAlert1('Saldo creado con exito')
                setClaseAlert1('success alertFlotante opacity-100')
                setAlert1(true)
                setTimeout(() => {    
                    setAlert1(false)
                    handleClose()
                }, 3000)
            }
            else
            {
                setClassWaitProcess('waitProcess')
                setTituloAlert1('Creacion de saldos')
                setTextoAlert1(statuscall.data.Message)
                setClaseAlert1('danger alertFlotante opacity-100')
                setAlert1(true)
                setTimeout(() => {
                    setAlert1(false)
                }, 3500)
            }                            
        }
        else
        {
            setClassWaitProcess('waitProcess')
            setTituloAlert1('Creacion de saldos')
            setTextoAlert1('Servidor no responde. Intentelo mas tarde')
            setClaseAlert1('danger alertFlotante opacity-100')
            setAlert1(true)
            setTimeout(() => {
                setAlert1(false)
            }, 3500)             
        }

    }

    const handleShow = () => setShow(true)
    const handleClose = () => {
        setIdsaldo('')
        setShow(false)
    }

    return(
    <div className='container'>
        <div className='col col-xl-12 col-lg-12 col-md-12 col-sm-12'>
                        
            <div className='row sabackComponent'>
                <div className='col col-xl-12 col-lg-12 col-md-12 col-sm-12'>
                    <h4>Administracion de usuarios</h4>
                </div> 
            </div>

            <div className='row sabackComponent'>

                <div className='col col-xl-3 col-lg-3 col-md-6 col-sm-12'>
                    <select className='safiltercontrols' onChange={handlerChangeCasino}>
                        <option value='0'>Seleccione Casino</option>
                        {casinosList}
                    </select>
                </div>

                <div className='col col-xl-3 col-lg-3 col-md-6 col-sm-12'>
                    <select className='safiltercontrols' onChange={handlerChangePerfil}>
                        <option value='0'>Seleccione Tipo Usuario</option>
                        {perfilesList}
                    </select>
                </div>                            

                <div className='col col-xl-3 col-lg-3 col-md-6 col-sm-12'>
                    <input className='safiltercontrols' type='text' value={searchmail} onChange={handlerChangeMail} placeholder='Ingrese mail'></input>
                </div>

                <div className='col col-xl-3 col-lg-3 col-md-6 col-sm-12'>
                    <button className='btn btn-adminsaprivate' onClick={handelSearch}>Buscar</button>
                </div>

            </div> 

            <div className='row sabackComponent'>
                    <div className='row saTitulosGrid'>
                        <div className='col col-xl-3 col-lg-3 col-md-3 col-sm-3'>Mail</div>
                        <div className='col col-xl-3 col-lg-3 col-md-0 col-sm-0'>Control</div>
                        <div className='col col-xl-3 col-lg-3 col-md-0 col-sm-0'>Control</div>
                        <div className='col col-xl-3 col-lg-3 col-md-3 col-sm-3'>Control</div>
                    </div> 
                    <div className='row saContainerGrid'>               
                        {dataList}
                    </div>
            </div>

            <div className='row sabackComponent'>
                <button onClick={crearUsuario} className='btn btn-adminsaprivateRegular'>Crear Usuario</button>
            </div>     
        </div>        


        <Modal show={showdesactivar} onHide={handleClosedesactivar} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Administracion de usuarios</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={classWaitProcess}>
                    <div className='loaderS divAbsolute'>
                    </div>
                </div>

                <div className='row divAbsolute'>
                    <div className='col col-lg-12'>
                        {alertDesactivate
                        ?<Alert variant={claseAlertDesactivate} onClose={() => setAlertDesactivate(false)} dismissible fade show>
                            <Alert.Heading>{tituloAlertDesactivate}</Alert.Heading>
                                <p>
                                    {textoAlertDesactivate}
                                </p>
                                <hr></hr>
                                <p class="mb-0"><button className='btn btn-adminsaprivateRegular' onClick={confirmaDesactivacion}>Confirmar</button><button className='btn btn-adminsaprivateRegular' onClick={() => setAlertDesactivate(false)}>Rechazar</button></p>    
                        </Alert>
                        :''
                        }

                        {alertDesactivate1
                        ?<Alert variant={claseAlertDesactivate1} onClose={() => setAlertDesactivate1(false)} dismissible fade show>
                        <Alert.Heading>{tituloAlertDesactivate1}</Alert.Heading>
                            <p>
                                {textoAlertDesactivate1}
                            </p>
                        </Alert>
                        :''                            
                        }
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Usuario                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <input type='text' value={mail} disabled='true'></input>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className='btn btn-adminsaprivateRegular' onClick={handleClosedesactivar}>
                    Cerrar
                </button>
                <button className='btn btn-adminsaprivateRegular' onClick={desactivacionUsuario}>
                    Desactivar
                </button>
            </Modal.Footer>
        </Modal>

        <Modal show={showactivar} onHide={handleCloseactivar} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Administracion de usuarios</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={classWaitProcess}>
                    <div className='loaderS divAbsolute'>
                    </div>
                </div>

                <div className='row divAbsolute'>
                    <div className='col col-lg-12'>
                        {alertActivate
                        ?<Alert variant={claseAlertActivate} onClose={() => setAlertActivate(false)} dismissible fade show>
                            <Alert.Heading>{tituloAlertActivate}</Alert.Heading>
                                <p>
                                    {textoAlertActivate}
                                </p>
                                <hr></hr>
                                <p class="mb-0"><button className='btn btn-adminsaprivateRegular' onClick={confirmaActivacion}>Confirmar</button><button className='btn btn-adminsaprivateRegular' onClick={() => setAlertActivate(false)}>Rechazar</button></p>    
                        </Alert>
                        :''
                        }

                        {alertActivate1
                        ?<Alert variant={claseAlertActivate1} onClose={() => setAlertActivate1(false)} dismissible fade show>
                        <Alert.Heading>{tituloAlertActivate1}</Alert.Heading>
                            <p>
                                {textoAlertActivate1}
                            </p>
                        </Alert>
                        :''                            
                        }
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Usuario                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <input type='text' value={mail} disabled='true'></input>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className='btn btn-adminsaprivateRegular' onClick={handleCloseactivar}>
                    Cerrar
                </button>
                <button className='btn btn-adminsaprivateRegular' onClick={activacionUsuario}>
                    Activar
                </button>
            </Modal.Footer>
        </Modal>    

        <Modal show={showreset} onHide={handleClosereset} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Administracion de usuarios</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={classWaitProcess}>
                    <div className='loaderS divAbsolute'>
                    </div>
                </div>

                <div className='row divAbsolute'>
                    <div className='col col-lg-12'>
                        {alertReset
                        ?<Alert variant={claseAlertReset} onClose={() => setAlertReset(false)} dismissible fade show>
                            <Alert.Heading>{tituloAlertReset}</Alert.Heading>
                                <p>
                                    {textoAlertReset}
                                </p>
                                <hr></hr>
                                <p class="mb-0"><button className='btn btn-adminsaprivateRegular' onClick={confirmaReset}>Confirmar</button><button className='btn btn-adminsaprivateRegular' onClick={() => setAlertReset(false)}>Rechazar</button></p>    
                        </Alert>
                        :''
                        }
                        {alertReset1    
                        ?<Alert variant={claseAlertReset1} onClose={() => setAlertReset1(false)} dismissible fade show>
                        <Alert.Heading>{tituloAlertReset1}</Alert.Heading>
                            <p>
                                {textoAlertReset1}
                            </p>
                        </Alert>
                        :''                            
                        }
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Usuario                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <input type='text' value={mail} disabled='true'></input>
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Password                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <input type='password' onChange={handlerChangePass} value={resetpassword}/>
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Repita Password                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <input type='password' onChange={handlerChangePassRpt} value={resetpasswordrpt}/>
                    </div>
                </div>                                
            </Modal.Body>
            <Modal.Footer>
                <button className='btn btn-adminsaprivateRegular' onClick={handleClosereset}>
                    Cerrar
                </button>
                <button className='btn btn-adminsaprivateRegular' onClick={resetPassword}>
                    Reset
                </button>
            </Modal.Footer>
        </Modal>

        <Modal show={showmodificar} onHide={handleClosemodificar} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Administracion de usuarios</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={classWaitProcess}>
                    <div className='loaderS divAbsolute'>
                    </div>
                </div>

                <div className='row divAbsolute'>
                    <div className='col col-lg-12'>
                        {alertModifica
                        ?<Alert variant={claseAlertModifica} onClose={() => setAlertModifica(false)} dismissible fade show>
                            <Alert.Heading>{tituloAlertModifica}</Alert.Heading>
                                <p>
                                    {textoAlertModifica}
                                </p>
                                <hr></hr>
                                <p class="mb-0"><button className='btn btn-adminsaprivateRegular' onClick={modificauser}>Confirmar</button><button className='btn btn-adminsaprivateRegular' onClick={() => setAlertModifica(false)}>Rechazar</button></p>    
                        </Alert>
                        :''
                        }

                        {alertModifica1
                        ?<Alert variant={claseAlertModifica1} onClose={() => setAlertModifica1(false)} dismissible fade show>
                        <Alert.Heading>{tituloAlertModifica1}</Alert.Heading>
                            <p>
                                {textoAlertModifica1}
                            </p>
                        </Alert>
                        :''                            
                        }
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Usuario                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <input type='text' value={mail} disabled='true'></input>
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Rut                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <input type='text' value={rut} disabled='true'></input>
                    </div>
                </div>                

                <div className='row'>
                    <div className='col col-lg-4'>
                        Password                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <input type='text' value={modificapassword} onChange={handlerChangeModificapassword}></input>
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Repita Password                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <input type='text' value={modificapasswordrpt} onChange={handlerChangeModificapasswordrpt}></input>
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Nombre                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <input type='text' value={modificanombre} onChange={handlerChangeModificanombre}></input>
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Apellido                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <input type='text' value={modificaapellido} onChange={handlerChangemodificaapellido}></input>
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Casino                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <select value={casino_id} onChange={handlerChangeCasinoID}>
                            {casinosList}
                        </select>
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Perfil                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <select value={perfil_id} onChange={handlerChangePerfilID}>
                            {perfilesList}
                        </select>
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <button className='btn btn-adminsaprivateRegular' onClick={handleClosemodificar}>
                    Cerrar
                </button>
                <button className='btn btn-adminsaprivateRegular' onClick={confirmamodifica}>
                    Modificar
                </button>
            </Modal.Footer>
        </Modal>

        <Modal show={showcrear} onHide={handleClosecrear} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Administracion de usuarios</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={classWaitProcess}>
                    <div className='loaderS divAbsolute'>
                    </div>
                </div>

                <div className='row divAbsolute'>
                    <div className='col col-lg-12'>
                        {alertCrea
                        ?<Alert variant={claseAlertCrea} onClose={() => setAlertCrea(false)} dismissible fade show>
                            <Alert.Heading>{tituloAlertCrea}</Alert.Heading>
                                <p>
                                    {textoAlertCrea}
                                </p>
                                <hr></hr>
                                <p class="mb-0"><button className='btn btn-adminsaprivateRegular' onClick={creauser}>Confirmar</button><button className='btn btn-adminsaprivateRegular' onClick={() => setAlertCrea(false)}>Rechazar</button></p>    
                        </Alert>
                        :''
                        }

                        {alertCrea1
                        ?<Alert variant={claseAlertCrea1} onClose={() => setAlertCrea1(false)} dismissible fade show>
                        <Alert.Heading>{tituloAlertCrea1}</Alert.Heading>
                            <p>
                                {textoAlertCrea1}
                            </p>
                        </Alert>
                        :''                            
                        }
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Mail                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <input type='text' onChange={handlerChangecreamail}></input>
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Rut                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <input type='text' value={crearut} onChange={handlerChangecrearut}></input>
                    </div>
                </div>                

                <div className='row'>
                    <div className='col col-lg-4'>
                        Password                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <input type='password' onChange={handlerChangecreapassword}></input>
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Repita Password                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <input type='password' onChange={handlerChangecreapasswordrpt}></input>
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Nombre                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <input type='text' onChange={handlerChangecreanombre}></input>
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Apellido                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <input type='text'onChange={handlerChangecreaapellido}></input>
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Casino                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <select onChange={handlerChangecreaCasinoID}>
                            <option value='0'>Seleccione Casino</option>
                            {casinosList}
                        </select>
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Perfil                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <select onChange={handlerChangecreaPerfilID}>
                            <option value='0'>Seleccione Perfil</option>
                            {perfilesList}
                        </select>
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <button className='btn btn-adminsaprivateRegular' onClick={handleClosecrear}>
                    Cerrar
                </button>
                <button className='btn btn-adminsaprivateRegular' onClick={confirmacrea}>
                    Crear
                </button>
            </Modal.Footer>
        </Modal>
    </div>    
    )
}
export default Grillasausuariosadmin
